// extracted by mini-css-extract-plugin
export default {"wrapperIframe":"Background_wrapperIframe__hJDc+","iframe":"Background_iframe__VYAb0","wrapper":"Background_wrapper__DEtgr","root":"Background_root__IxAD-"};